import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VRow,
        { staticClass: "mt-0", attrs: { "no-gutters": "" } },
        [
          _c(VSpacer),
          _c(
            VCol,
            { attrs: { cols: "4" } },
            [
              _c(VSelect, {
                attrs: {
                  items: _vm.diagnosticos,
                  label: "Diagnóstico:",
                  "item-text": "nome",
                  "item-value": "id",
                  "return-object": "",
                },
                model: {
                  value: _vm.diagnostico,
                  callback: function ($$v) {
                    _vm.diagnostico = $$v
                  },
                  expression: "diagnostico",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.diagnosticos.length > 0
        ? _c(
            "div",
            [
              _c(
                VRow,
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c("v-card-widget", { attrs: { title: "Informações" } }, [
                        _c(
                          "div",
                          {
                            attrs: { slot: "widget-content" },
                            slot: "widget-content",
                          },
                          [
                            _c(
                              VRow,
                              { attrs: { "no-gutters": "" } },
                              [
                                _c(VCol, { attrs: { cols: "6" } }, [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v("Diagnóstico: ")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-light" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.diagnostico.nome
                                            ? _vm.diagnostico.nome
                                            : ""
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm.usuario !== ""
                                  ? _c(VCol, { attrs: { cols: "6" } }, [
                                      _vm.chefia
                                        ? _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [_vm._v("Gestor(a):")]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [_vm._v("Servidor(a): ")]
                                          ),
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-light" },
                                        [_vm._v(_vm._s(_vm.usuario))]
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card-widget",
                        {
                          attrs: {
                            "enable-actions": _vm.actions,
                            title: _vm.titulo ? _vm.titulo : "Relatório",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { slot: "widget-content" },
                              slot: "widget-content",
                            },
                            [
                              _c("AppTutorial", {
                                attrs: { tutorial: _vm.visibleTutorial },
                              }),
                              _c(
                                VRow,
                                { attrs: { "no-gutters": "" } },
                                [_vm._t("body")],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              attrs: { slot: "widget-actions" },
                              slot: "widget-actions",
                            },
                            [
                              _c(
                                VRow,
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12" } },
                                    [_vm._t("actions")],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            [
              _c("app-alert", {
                attrs: {
                  type: "info",
                  icon: "info",
                  message: "Usuário não participou de nenhum diagnóstico.",
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }